// Constants
import { GA } from "@/app/constants/ga-constants"
import { STATUS_CODES } from "@/app/constants/status-constants"
import { NOTIFICATION_TYPE, NOTIFICATION_ICON, NOTIFICATION_URL } from "@/app/constants/notification-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Services
import notificationService from "@/app/services/main/notification/notification-service.js"
import ClubService from "@/app/services/main/club/club-service.js"
import PostService from "@/app/services/main/post/post-service"

// Mixins
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

// Third party libraries
import { format, parseISO } from "date-fns"
import EventBus from "@/app/bus/event-bus"

export default {
	name: "NotificationComponent",
	mixins: [GoogleAnalyticsMixins, userMixins, toastMessageMixins, tableMixins, switchPetMixins],
	props: {
		isDropdown: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	data() {
		return {
			// loaders
			isAPILoading: false,
			desc: true,
		}
	},
	computed: {
		notificationList() {
			const { getNotificationListPage, getNotificationListDropDown } = this.$store.getters

			return this.isDropdown ? getNotificationListDropDown : getNotificationListPage
		},
		userRole() {
			return this.$store.getters.getUserDetails.userRole
		},
	},
	watch: {
		$route: {
			async handler(newRoute) {
				if (newRoute.path !== "/products/product-list") {
					await this.refreshNotification()
				}
			},
			deep: true,
		},
		notificationApiError(newVal) {
			if (newVal && this.isDropdown) {
				this.showAPIErrorToast(newVal.message, newVal.res)
			}
		},
	},
	async created() {
		await this.getNotificationsByPageType()
		EventBus.$on("refreshNotification", this.refreshNotification)
	},
	beforeDestroy() {
		EventBus.$off("refreshNotification", this.refreshNotification)
	},
	methods: {
		async refreshActivePetData() {
			this.getNotificationsByPageType().then(await this.$store.dispatch("setTreatmentOverdueCount"))
		},
		async getNotificationsByPageType() {
			// check if dropdown - params not needed
			if (this.isDropdown) {
				await this.getNotificationList({ desc: this.desc })
			} else {
				await this.getTableContent()
			}
		},
		async refreshNotification() {
			await this.getNotificationList({ desc: this.desc })
		},
		getIcon({ notificationTypeCode }) {
			const notificationIcon = NOTIFICATION_ICON[notificationTypeCode]

			return require(`@/assets/images/_shared/${notificationIcon}`)
		},
		formatDate(date) {
			return format(parseISO(date), "dd-MMM-yyyy")
		},
		sendNotificationAnalytics() {
			this.sendEventTrackingToGA(
				GA.NOTIFICATIONS.NOTIFICATION_PAGE.ACTION,
				GA.NOTIFICATIONS.CATEGORY,
				GA.NOTIFICATIONS.NOTIFICATION_PAGE.LABEL
			)
		},

		getOriginUrl(url) {
			const { origin } = new URL(url)
			return origin
		},

		async goToNotification(notification) {
			const { notificationTypeCode, targetId, read, status, matingId } = notification

			const originUrl = window.location.origin

			const {
				GEN_INFO: genInfo,
				TREATMENT: treatment,
				ADM_NOTIF,
				SOCIAL_GRP,
				CONTENT,
				REMINDER,
				PET_ORDER,
				PRODUCT,
				CREDIT,
				PUPPY_SELL,
				BREEDER,
				SUBS,
				LITTER_REMINDERS
			} = NOTIFICATION_TYPE

			switch (notificationTypeCode) {
				case genInfo:
					this.$store.commit("setGenInfoId", targetId)
					break

				case treatment:
					await this.$store.dispatch("getScheduleData", targetId)
					break

				case REMINDER:
					this.$store.commit("setReminder", notification)
					break

				case PET_ORDER:
					break
				//this.$store.commit('setReminder', notification);
			}

			// set to read true if false
			if (!read) {
				await this.markReadNotification(notification)
			}
			if (notification.notificationTypeCode === ADM_NOTIF) {
				// Refresh notif lsit
				this.getNotificationList({ desc: this.desc })

				const imageUrl = notification.imageUrl
					? notification.imageUrl
					: require("@/assets/images/_shared/notification-dog.png")
				const confirmText = notification.link ? "Go to link" : "Got it"
				this.$swal({
					imageHeight: "30px",
					imageUrl: `${imageUrl}`,
					imageAlt: "Pet Notif",
					title: notification.title,
					html: notification.body.replace(/\\n/g, "").replace(/\n/g, "<br/>"),
					confirmButtonColor: "#4B8BFF",
					confirmButtonText: confirmText,
					customClass: {
						container: "container-notification",
						header: "header-notification",
						content: "content-notification",
						title: "title-notification",
						confirmButton: "confirm-button-notification",
					},
				}).then((result) => {
					if (result.value) {
						if (notification.link && originUrl !== this.getOriginUrl(notification.link)) {
							window.open(notification.link, "_blank")
						} else {
							if(notification.link)
								window.open(notification.link, "_self")
						}
					}
				})
			} else if (notification.notificationTypeCode === PET_ORDER) {
				if (status === "A") {
					this.$router.push(NOTIFICATION_URL[notificationTypeCode])
				} else {
					this.$swal({
						imageHeight: "30px",
						imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
						imageAlt: "Sad Dog",
						title: "Dog Purchase",
						text: notification.title,
						confirmButtonColor: "#4B8BFF",
						confirmButtonText: "Got it",
					})
				}
			} else if (notification.notificationTypeCode === PRODUCT) {
				if(notification.targetId == this.$route.params.orderId){
					return;
				}

				this.$router.push(`${NOTIFICATION_URL[notificationTypeCode]}/${notification.targetId}/view`)
			} else if (notification.notificationTypeCode === CREDIT) {
				const imageUrl =
					notification.type === "add"
						? require("@/assets/images/_shared/success-dog.png")
						: require("@/assets/images/_shared/sad-dog.png")

				this.$swal({
					imageHeight: "30px",
					imageUrl,
					imageAlt: "Notification Dog",
					title: notification.title,
					text: notification.body,
					confirmButtonColor: "#4B8BFF",
					confirmButtonText: "Got it",
				})
			} else if (notification.notificationTypeCode === PUPPY_SELL) {
				if (notification.title === "Your puppy has been sold.") {
					this.$router.push(`${BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO}?id=${notification.targetId}`)
				} else if (notification.title === 'Congratulations on your new puppy! To arrange pick-up, contact your breeder using the provided details.') {
					const modalContent = `
						<div style="text-align: left">
							<p style="margin-bottom: 1rem; text-align: justify">${notification.title}</p>
							<p style="margin-bottom: 0.3rem; text-align: justify"><strong>$1,500</strong> store credit has been added to your account for use on any product in your personalized Pet Shop.</p>
						</div>
					`
					this.$swal({
						imageHeight: "30px",
						imageUrl: `${require("@/assets/images/_shared/notification-dog.png")}`,
						imageAlt: "Puppy Purchase",
						title: "Puppy Purchase",
						html: modalContent,
						confirmButtonColor: "#4B8BFF",
						cancelButtonColor: '#d33',
						cancelButtonText: 'Close',
						confirmButtonText: 'Shop',
						showCancelButton: true,
						allowOutsideClick: false,
						customClass: {
							container: "container-notification",
							header: "header-notification",
							content: "content-notification",
							title: "title-notification",
							confirmButton: "confirm-button-notification",
							cancelButton: "confirm-button-notification",
						},
					}).then((result) => {
						if (result.value) {
							this.$router.push(`/products`)
						} else {
							this.$router.push({ path: `/purchases/puppies/${notification.puppySellPurchaseId}/view`, force: true }).catch(err => {});
						}
					})
				} else {
					this.$router.push(`/purchases/puppies/${notification.puppySellPurchaseId}/view`)
					
				}
			} else if (notification.notificationTypeCode === BREEDER) {
				const imageUrl =
					notification.status === "A"
						? require("@/assets/images/_shared/success-dog.png")
						: require("@/assets/images/_shared/sad-dog.png")

				const content = notification.status === "A" ? "<center>You are now a verified Love My Dog Club breeder.</center>" : `<center>We have been unable to verify certain aspects of your Breeder practices, please contact us via <a href="mailto: services@lovemydogclub.com.au">services@lovemydogclub.com.au</a> to discuss.</center>`
				this.$swal({
					imageHeight: "30px",
					imageUrl,
					imageAlt: "Notification Dog",
					title: notification.status === "A" ? "Congratulations!" :  notification.title,
					html: content,
					confirmButtonColor: "#4B8BFF",
					confirmButtonText: "Got it",
					customClass: {
						container: "container-notification",
						header: "header-notification",
						content: "content-notification",
						title: "title-notification",
						confirmButton: "confirm-button-notification",
					},
				})

				await this.getNotificationList({ desc: this.desc })
			} else if (notification.notificationTypeCode === SUBS) {
				if(notification.targetId == this.$route.params.subscriptionId){
					return;
				}

				this.$router.push(`${NOTIFICATION_URL.SUBS}/${notification.targetId}/view`)
			} else if (notification.notificationTypeCode === LITTER_REMINDERS) {
				this.$router.push(`${BREEDER_ROUTES.LITTER_REMINDER_AND_NOTES}?matingId=${matingId}&reminderId=${targetId}`);
			}
			 else {
				if (this.$route.path === NOTIFICATION_URL[notification.notificationTypeCode]) {
					await this.getNotificationList({ desc: this.desc })
				}

				this.$router.push(NOTIFICATION_URL[notificationTypeCode])

				if (notification.notificationTypeCode === SOCIAL_GRP || notification.notificationTypeCode === CONTENT) {
					if (notification.notificationTypeCode === CONTENT) {
						PostService.getPostById(notification.contentId).then((res) => {
							if (res.status === STATUS_CODES.SUCCESS) {
								// set post content
								this.$store.commit("setPostContent", res.data)
							}
						})
					}
					// get group information
					let group = {}

					const queryParams = {
						f_groupId: notification.groupId,
					}

					ClubService.getGroups(queryParams)
						.then((res) => {
							if (res.status === STATUS_CODES.SUCCESS) {
								group = res.data.data

								// set activeGroupId
								this.$store.commit("setActiveGroup", group[0])
							} else {
								this.showCustomErrorToast(res.data.errors[0].message, null, true)
							}
						})
						.catch(() => {
							this.showGenericErrorToast()
						})
				}
			}
		},
		markReadNotification(notification) {
			return notificationService.putNotification(notification.id).then((res) => {
				if (res.status !== STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showGenericErrorToast()
				}
			})
		},
		async markAllAsReadNotifications(e) {
			e.stopPropagation() // prevents the bootstrap dropdown from closing

			return notificationService.markAllAsReadNotifications().then(async (res) => {
				if (res.status !== STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showGenericErrorToast()
				} else {
					this.showCustomSuccessToast(
						"Success!",
						"Your notifications have all been marked as read successfully."
					)
					EventBus.$emit("refreshNotification")
				}
			})
		},
		async getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			await this.getNotificationList({ page, limit, sortBy, desc })
		},
		async getNotificationList(queryParams) {
			this.isAPILoading = true
			await this.$store
				.dispatch("setNotificationList", {
					activePetId: this.getActivePet.id,
					queryParams: queryParams,
					isPage: !this.isDropdown,
				})
				.then(() => {
					const dataTable = this.notificationList.tableData.filter(
						(item) => item.notificationTypeCode !== "CONTENT"
					)

					this.tableContent =
						this.userRole === "BRDER"
							? { ...this.notificationList, tableData: dataTable }
							: this.notificationList
					this.isAPILoading = false
				})
		},
	},
}
